import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicAlarm({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 2.36a6.25 6.25 0 014.02 11.04l1.06 1.05c.2.2.2.51 0 .7l-.36.36a.5.5 0 01-.7 0l-1.28-1.28a6.22 6.22 0 01-5.48 0l-1.28 1.28a.5.5 0 01-.7 0l-.36-.35a.5.5 0 010-.71l1.06-1.05A6.24 6.24 0 018 2.36zm0 1.5a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM7.75 5.3c.41 0 .75.34.75.75v1.72l1.76.03a.75.75 0 11-.02 1.5l-2.5-.04A.75.75 0 017 8.51V6.05c0-.41.34-.75.75-.75zM4.15.7a.5.5 0 01.7.1l.3.42a.5.5 0 01-.12.7l-2.69 1.9a.5.5 0 01-.7-.11l-.29-.41a.5.5 0 01.12-.7zm7 .1a.5.5 0 01.7-.1l2.68 1.91a.5.5 0 01.12.7l-.3.4a.5.5 0 01-.7.12l-2.68-1.92a.5.5 0 01-.12-.7z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicAlarm.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicAlarm.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicAlarm svgRef={ref} {...props} />);
export default ForwardRef;
